import { isObjectNotNull, validateEmail } from "../../utils";
import {
  PASSWORD_MIN_LENGTH,
  VALIDATION_MESSAGES,
  FORM_FIELDS,
} from "../../constants/ValidationMessage";

import {
  validateFirstName,
  validateLastName,
} from "../../utils/validators";
type Errors = Record<string, string>;

export const validateFormValues = (
  formValues: any,
  signUpData: any,
): Errors => {
  const errors: Errors = {};
  const isSignUp = !isObjectNotNull(signUpData);

  if (isSignUp) {
    const prenomError = validateFirstName(formValues[FORM_FIELDS.PRENOM]);
    if (prenomError) {
      errors[FORM_FIELDS.PRENOM] = prenomError;
    }


    const nomError = validateLastName(formValues[FORM_FIELDS.NOM]);
    if (nomError) {
      errors[FORM_FIELDS.NOM] = nomError;
    }

    if (!formValues[FORM_FIELDS.EMAIL]) {
      errors[FORM_FIELDS.EMAIL] = VALIDATION_MESSAGES.REQUIRED.EMAIL;
    } else if (!validateEmail(formValues[FORM_FIELDS.EMAIL])) {
      errors[FORM_FIELDS.EMAIL] = VALIDATION_MESSAGES.INVALID.EMAIL;
    }
    const password = formValues[FORM_FIELDS.PASSWORD];
    const confirmPassword = formValues[FORM_FIELDS.CONFIRM_PASSWORD]

    if (!password) {
      errors[FORM_FIELDS.PASSWORD] =
        VALIDATION_MESSAGES.REQUIRED.PASSWORD;
    } else if (password.length < PASSWORD_MIN_LENGTH) {
      errors[FORM_FIELDS.PASSWORD] =
        VALIDATION_MESSAGES.INVALID.PASSWORD_MIN_LENGTH(
          PASSWORD_MIN_LENGTH
        );
    }

    if (!confirmPassword) {
      errors.confirmPassword =
        VALIDATION_MESSAGES.REQUIRED.CONFIRM_PASSWORD;
    } else if (password && password !== confirmPassword) {
      errors.confirmPassword =
        VALIDATION_MESSAGES.INVALID.PASSWORD_MISMATCH;
    }
  }

  return errors;
};